import React from "react";

import { Badge } from "./base/badge";
import { CopyCellButton } from "./tables/data-table/copy-cell-button";

export function Tags({
  tags,
  copyable,
}: {
  tags: string[];
  copyable?: boolean;
}) {
  return (
    <span className="inline-flex flex-wrap gap-1">
      {tags?.map((tag) => (
        <Badge key={tag} variant="secondary">
          {tag}
          {copyable && <CopyCellButton value={tag} />}
        </Badge>
      ))}
    </span>
  );
}
